import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import SearchField from 'react-search-field';

const RelationList = ({heading, language, contentTypes}) => {
    const [contentTypesList, setContentTypesList] = useState()


    useEffect(() => {
        const getContentType = async () => {
            setContentTypesList(contentTypes)
        }
        getContentType()

    },[contentTypes])
    
    const searchContentTypes = (keyword) => {
        setContentTypesList(
            contentTypes.filter((contentType) => contentType.contentTypeName.toLowerCase().includes(keyword.toLowerCase()))
        )
    }
    let content

    if(contentTypesList){
        content = (
            <div>
            <h3>{heading}</h3>
            <SearchField classNames="searchInput" onChange={searchContentTypes} placeholder={language.value === 'DA' ? 'Søger i artikelnavn' : 'Search in article name'} />
            <div id="cc_relation_list">
            {
                contentTypesList.map((contentType) => (
                    <div key={contentType.id} className="cc_relation_list_item"> 
                        <div>
                            <Link to={`/content/${contentType.id}`}>{contentType.contentTypeName}</Link>
                        </div>
                    </div>
                ))
            }
            </div>
        </div>
        )
    }

    return (
        <>
            {content}
        </>
    )
}

export default RelationList
